var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationWindow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9844 18.0156V12.0156C15.9844 10.7344 15.625 9.67188 14.9062 8.82812C14.1875 7.95312 13.2188 7.51562 12 7.51562C10.7812 7.51562 9.8125 7.95312 9.09375 8.82812C8.375 9.67188 8.01562 10.7344 8.01562 12.0156V18.0156H15.9844ZM18 16.9844L20.0156 19V19.9844H3.98438V19L6 16.9844V12.0156C6 10.4531 6.39062 9.09375 7.17188 7.9375C7.98438 6.78125 9.09375 6.03125 10.5 5.6875V4.98438C10.5 4.57812 10.6406 4.23438 10.9219 3.95312C11.2031 3.64062 11.5625 3.48438 12 3.48438C12.4375 3.48438 12.7969 3.64062 13.0781 3.95312C13.3594 4.23438 13.5 4.57812 13.5 4.98438V5.6875C14.9062 6.03125 16 6.78125 16.7812 7.9375C17.5938 9.09375 18 10.4531 18 12.0156V16.9844ZM13.4062 22.4219C13 22.7969 12.5312 22.9844 12 22.9844C11.4688 22.9844 11 22.7969 10.5938 22.4219C10.1875 22.0156 9.98438 21.5469 9.98438 21.0156H14.0156C14.0156 21.5469 13.8125 22.0156 13.4062 22.4219Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 6,
    r: 6,
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationWindow);
export default __webpack_public_path__ + "static/media/NotificationWindow.c5030cec49f92a54312174b0aaa76513.svg";
export { ForwardRef as ReactComponent };